import { EPortal } from '@/frontend/src/types/portal';

export const isFrenchPortal = (
    portal: EPortal,
): portal is EPortal.LogicImmo | EPortal.SeLoger => {
    return portal === EPortal.SeLoger || portal === EPortal.LogicImmo;
};

export const getGeoPortalIdentifier = (portal: EPortal) => {
    switch (portal) {
        case EPortal.Immonet:
            return 'IMN-DEU';
        case EPortal.Immowelt:
            return 'IWT-DEU';
        case EPortal.Immoweb:
            return 'IWB-BEL';
        case EPortal.SeLoger:
            return 'SLG-FRA';
        case EPortal.LogicImmo:
            return 'LIM-FRA';
        default:
            throw new Error(`Portal ${portal} is not supported`);
    }
};
